import React, { ReactNode } from 'react';

export type PanelProps = {
    flexDirection?: 'row' | 'column';
    children?: ReactNode;
    noMinHeight?: boolean;
    flushTabs?: boolean;
    fullWidth?: boolean;
};

const Panel = ({
    children,
    flexDirection = 'row',
    noMinHeight = false,
    flushTabs = false,
    fullWidth = false,
}: PanelProps): JSX.Element => {
    const cssName = flexDirection === 'row' ? 'panel-row' : 'panel-column';

    return (
        <section
            className={`panel ${cssName}${noMinHeight ? ' no-min-height' : ''}${flushTabs ? ' panel-flush-tabs' : ''}${fullWidth ? ' panel-full-width' : ''}`}
        >
            {children}
        </section>
    );
};

export default Panel;
